import React from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import { Box, Flex } from "theme-ui"
import CareersCard from "components/cards/careers-card"
import ShareButtonSocial from "components/share-button-social"
// markup
const IndexPage = ({ location, data }) => {
    const { post } = data
    const customJsx = (
        <>
            <CareersCard
                url={`/${location.pathname.split("/")[1]}`}
                slug="join-our-team"
                title={post.title}
                emp_type={post.employment_type}
                submit={true}
            />
            <Flex>
                <Box>
                    <p>Job Description</p>
                    <div
                        className="content-paragraph"
                        dangerouslySetInnerHTML={{
                            __html: post.job_description,
                        }}
                    />
                </Box>
            </Flex>
            <Flex>
                <Box>
                    <p>Requirement</p>
                    <div
                        className="content-paragraph"
                        dangerouslySetInnerHTML={{
                            __html: post.requirements,
                        }}
                    />
                </Box>
            </Flex>
            <Flex>
                <Box>
                    <p>What We Offer</p>
                    <div
                        className="content-paragraph"
                        dangerouslySetInnerHTML={{
                            __html: post.what_we_offer,
                        }}
                    />
                </Box>
            </Flex>
            <ShareButtonSocial path={location.pathname} url={location.href} />
        </>
    )
    const breadcrums = ["Careers", post.title]

    const arrData = {
        location,
        data,
        bgColor:
            "linear-gradient(90deg, #f9e07f 25%, #f9e38e 25%, #f9e38e 50%, #f9e07f 50%, #f9e07f 75%, #f9e38e 75%, #f9e38e 100%)",
        // galleryMinWidth: "40%", //default 0
        customElement: customJsx,
        parentLink: "careers",
        breadcrums // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query CareerPostQuery($slug: String!) {
        pageData: strapiPage(
            slug: { eq: "eip-careers" }
            company: { shortname: { eq: "EIP" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Image_Size
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
                Gallery_Image {
                    title
                    media {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                        }
                        publicURL
                    }
                }
                Accordion {
                    content
                    title
                }
                external_script {
                    name
                    script
                }
            }
        }
        post: strapiJob(slug: { eq: $slug }) {
            id
            title
            slug
            description
            employment_type
            level
            job_description
            what_we_offer
            requirements
            how_to_apply
            department {
                name
                shortname
            }
        }
    }
`
